import { render } from "./LayoutSingle.vue?vue&type=template&id=6603f1e5&scoped=true"
import script from "./LayoutSingle.vue?vue&type=script&lang=ts"
export * from "./LayoutSingle.vue?vue&type=script&lang=ts"

import "./LayoutSingle.vue?vue&type=style&index=0&id=6603f1e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6603f1e5"

export default script